export default __webpack_public_path__ + "static/Milan-Laser-Hair-Removal-Announces-New-Chief-Executive-Officer-c2469fa96a6c9deaba4da83d8ad2466d.pdf";